import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.patient-groups': {
         patientGroups: 'Oznaczenia pacjenta',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.patient-groups');
